<rt-input
  #inputComponent
  variant="rounded"
  [placeholder]="placeholder && (placeholder | translate)"
  (valueChange)="valueChange.emit($event)"
  layout-vertical
  class="phone-input"
></rt-input>
